export const LINEUPS = {
  ACTION_TYPES: {
    lineupsDisplayHandler: 'lineupsDisplayHandler',
    initializeFootballYard: 'initializeFootballYard',
    onPlayerCardPopupClick: 'onPlayerCardPopupClick',
    toggleFormationView: 'toggleFormationView'
  },
  ASSIST: {
    // Statistic-type icon id used to render the assist icon (StatisticTypes library).
    ICON_IMAGE_ID: 225
  },
  STATUS: {
    injuriesAndSuspensions: 'injuriesAndSuspensions',
    expected: 'Expected',
    confirmed: 'Confirmed',
    notConfirmed: 'NotConfirmed',
  },
  CARD_TYPES: {
    none: 0,
    yellowCard: 1,
    redCard: 2,
    secondYellow: 3,
  },
  MEMBERS_STATUS: {
    none: 0,
    starting: 1,
    substitute: 2,
    missing: 3,
    management: 4,
    doubtful: 5
  },
  POSITIONS: {
    goalkeeper: 1,
    defender: 2,
    midfielder: 3,
    attacker: 4
  },
  SUBSTITUTION_TYPES: {
    in: 1,
    out: 2,
  },
  INJURY_CATEGORY: {
    medical: 1,
    internationalDuty: 2,
    personalReasons: 3,
  },
  GOAL_SUB_TYPES: {
    fieldGoal: 1,
    ownGoal: 2,
    penalty: 3,
  },
  RED_CARD_SUB_TYPES: {
    straight: 20,
    secondYellow: 21
  },
  EVENT_TYPES: {
    goal: 1,
    yellowCard: 2,
    redCard: 3,
    substitution: 1000,
    penaltyMiss: 6,
  },
  SUSPENSION_TYPES: {
    redCard : 3,
    yellowCards : 2
  },
  RATING_TYPES: {
    low: 4.9,
    moderate: 5.9,
    medium: 6.9,
    high: 7
  },
  RATING_CLASS_NAMES: {
    noRating: 'no-rating',
    low: 'low',
    moderate: 'moderate',
    medium: 'medium',
    high: 'high',
    best: 'best'
  },
  RATIO: 754.0 / 1186.0,
  MOBILE_PLAYER_SIZE: 0.13,
  DESKTOP_PLAYER_SIZE: 0.09,
  FORMATION_STATUS_ICON_SIZE: 16,
  FORMATION_COMPETITOR_ICON_SIZE: 12,
  PLAYERS_LIST_ICON_SIZE: 14
};

LINEUPS.ANALYTICS = {
  ACTION_TYPES: {
    onPlayerClick: 'onPlayerClick'
  },

  STATUSES: {
    [LINEUPS.STATUS.injuriesAndSuspensions]: 'injuries&suspensions',
      [LINEUPS.STATUS.expected]: 'expected-lineups',
      [LINEUPS.STATUS.confirmed]: 'confirmed-lineups',
      [LINEUPS.STATUS.notConfirmed]: 'not-confirmed-lineups',
  },

  PLAYER_STATUS: {
    lineups: 'lineups',
    bench: 'bench',
  }
};